// Utilidad simple para comparar dos versiones de un flujo (nodes/edges)
// Retorna un resumen de cambios: agregados, eliminados y modificados.

const pickComparableNode = (n) => ({
  id: n?.id,
  type: n?.type,
  position: n?.position,
  data: n?.data,
});

const pickComparableEdge = (e) => ({
  id: e?.id,
  type: e?.type,
  source: e?.source,
  target: e?.target,
  sourceHandle: e?.sourceHandle,
  targetHandle: e?.targetHandle,
  data: e?.data,
});

const stableStringify = (obj) => {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (value && typeof value === 'object') {
      if (seen.has(value)) return '[Circular]';
      seen.add(value);
      // ordenar keys para estabilidad
      return Object.keys(value)
        .sort()
        .reduce((acc, k) => {
          acc[k] = value[k];
          return acc;
        }, {});
    }
    return value;
  });
};

const diffById = (beforeArr, afterArr, pickFn) => {
  const beforeMap = new Map((beforeArr || []).map((x) => [x.id, pickFn(x)]));
  const afterMap = new Map((afterArr || []).map((x) => [x.id, pickFn(x)]));

  const added = [];
  const removed = [];
  const modified = [];

  for (const [id, afterVal] of afterMap.entries()) {
    if (!beforeMap.has(id)) {
      added.push(afterVal);
      continue;
    }
    const beforeVal = beforeMap.get(id);
    if (stableStringify(beforeVal) !== stableStringify(afterVal)) {
      modified.push({ before: beforeVal, after: afterVal });
    }
  }

  for (const [id, beforeVal] of beforeMap.entries()) {
    if (!afterMap.has(id)) removed.push(beforeVal);
  }

  return { added, removed, modified };
};

const diffFlow = (beforeFlow, afterFlow) => {
  const beforeNodes = beforeFlow?.nodes || [];
  const afterNodes = afterFlow?.nodes || [];
  const beforeEdges = beforeFlow?.edges || [];
  const afterEdges = afterFlow?.edges || [];

  return {
    nodes: diffById(beforeNodes, afterNodes, pickComparableNode),
    edges: diffById(beforeEdges, afterEdges, pickComparableEdge),
  };
};

export default diffFlow;
export { diffFlow };
